<div class="d-flex justify-content-end px-2 my-2"><img mat-dialog-close (click)="closer()"
        src="/icons/close-light-grey.svg" width="20px"></div>
<div class="p-4">
    <app-coreMaterialTab [caller]="'submitCore'"></app-coreMaterialTab>
</div>